import { SubjectsFieldsFragment } from 'api/graphql-types';
import { Icon } from 'components/icon/icon';
import { NextLink } from 'components/next-link';
import { Typography } from 'components/typography';

import IcnCarotRight from 'public/assets/icons/carot-right.svg';

import styles from './subjects.module.scss';

export interface ISubjectsProps {
	module: SubjectsFieldsFragment;
}

const Subjects = (props: ISubjectsProps): React.JSX.Element => {
	const subHeadingTag = props.module.overviewTitle ? 'h3' : 'h2';

	const subjects = [
		...(props.module.subjects || []),
		...(props.module.projects || []),
		...(props.module.themes || [])
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	].sort((left, right) => left.data.attributes!.title!.localeCompare(right.data.attributes!.title!));

	return (
		<div className={styles.Subjects}>
			{props.module.overviewTitle && <h2>{props.module.overviewTitle}</h2>}
			<div className={styles.description}>{props.module.description}</div>
			<div className={styles.cards}>
				{subjects?.map((subject: any, index: number) => (
					<NextLink href={subject?.data?.attributes?.slug} key={index}>
						<span className={styles.card}>
							<div className={styles.header}>
								<span className={styles.icon}>
									<Icon customIcon={<IcnCarotRight />} size="12px" />
								</span>
								<Typography tag={subHeadingTag} variant="h5" className={styles.cardTitle}>
									{subject?.data?.attributes?.title}
								</Typography>
							</div>
							<div className={styles.description}>{subject?.data?.attributes?.shortDescription}</div>
						</span>
					</NextLink>
				))}
			</div>
		</div>
	);
};

export default Subjects;
